import React from 'react';

import { Container, Row, Col } from 'react-bootstrap';
import Link, { LinkGroup } from 'ui-kit/link/link';

import Facebook from 'ui-kit/icons/social-media-icons/facebook/facebook';
import Instagram from 'ui-kit/icons/social-media-icons/instagram/instagram';
import Twitter from 'ui-kit/icons/social-media-icons/twitter/twitter';

import './style.css';

const FooterContact = ({ title, name, addressLine1, addressLine2, addressLine3, addressLine4, phone, email }) => {
    return (
        <div className="footer-contact">
            {title && <div className="footer-contact-title">{title}</div>}
            {name && <div className="footer-contact-name">{name}</div>}
            {addressLine1 && <div>{addressLine1}</div>}
            {addressLine2 && <div>{addressLine2}</div>}
            {addressLine3 && <div>{addressLine3}</div>}
            {addressLine4 && <div>{addressLine4}</div>}
            {phone && <div>{phone}</div>}
            {email && (
                <div>
                    <a href={`mailto:${email}`}>{email}</a>
                </div>
            )}
        </div>
    );
};

const Footer = () => (
    <footer>
        <Container fluid className="footer-contacts">
            <Row className="">
                <Col xs={12} md={4} className="d-flex justify-content-end footer-contact-col">
                    <FooterContact
                        title="Mailing Address"
                        addressLine1="P.O. Box 1271"
                        addressLine2="Muncie, Indiana 47308"
                    />
                </Col>
                <Col xs={12} md={4} className="mt-4 mt-md-0 d-flex justify-content-start footer-contact-col">
                    <FooterContact
                        title="Office Location"
                        addressLine1="MadJax"
                        addressLine2="515 East Main Street"
                        addressLine3="Suite 119"
                        addressLine4="Muncie, Indiana 47305"
                        phone="765-201-8928"
                        email="mlb@muncielandbank.org"
                    />
                </Col>
                <Col xs={12} md={4} className="mt-4 mt-md-0 d-flex justify-content-start footer-contact-col">
                    <LinkGroup className="footer-link-group">
                        <Link to="/privacy-policy" label="Privacy Policy" />
                        <Link to="/terms-and-conditions" label="Terms and Conditions" />
                        <Link to="/opportunities/jobs" label="Job Opportunities" />
                    </LinkGroup>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={4} className="d-flex justify-content-end pr-5 footer-contact-col">
                    <a href="https://www.facebook.com/MuncieLandBank" target="window">
                        <Facebook variant="light" />
                    </a>
                    <a href="https://www.instagram.com/muncielandbank/" target="window">
                        <Instagram variant="light" />
                    </a>
                    <a href="https://twitter.com/MuncieLandBank" target="window">
                        <Twitter variant="light" />
                    </a>
                </Col>
                <Col xs={12} md={4} className="mt-4 mt-md-0 d-flex justify-content-start footer-contact-col" />
                <Col xs={12} md={4} className="mt-4 mt-md-0 d-flex justify-content-start footer-contact-col" />
            </Row>
        </Container>
        <div className="copyright" align="center">
            © 2021 Muncie Land Bank, Inc. All rights reserved.
        </div>
    </footer>
);

export default Footer;
